'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIcofont = require('react-icofont');

var _reactIcofont2 = _interopRequireDefault(_reactIcofont);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartDropdownItem = function (_React$Component) {
    _inherits(CartDropdownItem, _React$Component);

    function CartDropdownItem() {
        _classCallCheck(this, CartDropdownItem);

        return _possibleConstructorReturn(this, (CartDropdownItem.__proto__ || Object.getPrototypeOf(CartDropdownItem)).apply(this, arguments));
    }

    _createClass(CartDropdownItem, [{
        key: 'generateChosenOptionsListNew',
        value: function generateChosenOptionsListNew() {

            var res = this.props.itemOptionCategories.map(function (cOption) {
                var coKeyVal = cOption.selectedKeys.reduce(function (acc, key) {
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {});

                return Object.keys(coKeyVal).map(function (key, i) {
                    var optionPrefix = "";

                    if (coKeyVal[key] > 1) {
                        optionPrefix = coKeyVal[key] + ' x ';
                    }

                    return _react2.default.createElement(
                        'span',
                        { key: key + '-' + i + '-' + coKeyVal[key] },
                        _react2.default.createElement(
                            'small',
                            {
                                className: "text-secondary" },
                            optionPrefix,
                            key
                        ),
                        ' ',
                        _react2.default.createElement('br', null)
                    )

                    // <li key = {`${key}-${i}-${coKeyVal[key]}`} className = "small">{optionPrefix}{key}</li>
                    ;
                });
            });

            return _react2.default.createElement(
                'ul',
                { className: 'list-unstyled unstyled-item mt-n1 mb-1' },
                res
            );
        }
    }, {
        key: 'render',
        value: function render() {

            var item = this.props.item;
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'mb-0 text-dark' },
                    _react2.default.createElement(
                        'p',
                        { className: 'location-card-ico order-icon mb-1' },
                        _react2.default.createElement(_reactIcofont2.default, { icon: this.props.icoIcon, className: "mr-1 " + this.props.iconClass })
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'location-card-title display-inline' },
                        this.props.title
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'float-right text-dark' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            '$',
                            item.itemQtyPrice ? Utils.toRoundStr(item.itemQtyPrice, 2) : Utils.toRoundStr(item.itemPrice * item.itemQty, 2)
                        )
                    )
                ),
                this.generateChosenOptionsListNew()
            );
        }
    }]);

    return CartDropdownItem;
}(_react2.default.Component);

CartDropdownItem.propTypes = {
    title: _propTypes2.default.string.isRequired,
    price: _propTypes2.default.string.isRequired,
    icoIcon: _propTypes2.default.string.isRequired,
    iconclass: _propTypes2.default.string.isRequired
};

CartDropdownItem.defaultProps = {
    title: '',
    price: '',
    icoIcon: '',
    iconclass: ''
};

exports.default = CartDropdownItem;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/CartDropdownItem.jsx
// module id = 552
// module chunks = 0